import { FileUpIcon, ListIcon } from 'lucide-react'

const ProductImportMenuItems = [
  {
    label: 'import_as_excel',
    href: '/products/import/excel/create',
    icon: FileUpIcon
  },
  {
    label: 'excel_imports',
    href: '/products/import/excel',
    icon: ListIcon
  },
  {
    label: 'bulk_picture_import',
    href: '/products/import/picture/create',
    icon: FileUpIcon
  },
  {
    label: 'bulk_picture_imports',
    href: '/products/import/picture',
    icon: ListIcon
  }
]

export default ProductImportMenuItems
